import {
  createHookStore,
  createUseSelector,
  STORE_NAMES
} from '@namespace/helpers-store';

export const initialState = {
  cryptoRate: {},
  isRatesLoaded: false,
  isProcessing: false
};

export const useCryptoRateStore = createHookStore(
  STORE_NAMES.CRYPTO_RATE,
  initialState
);

export const useCryptoRateSelector = createUseSelector(useCryptoRateStore);
